import { IdentifierDTO } from '@zazume/zzm-base';

export const DocumentsKeys = {
  base: 'document',
  all: (filter = 'all'): string[] =>
    [DocumentsKeys.base, filter],
  byId: (documentId: IdentifierDTO) =>
    [DocumentsKeys.base, documentId]
};
